import React, { forwardRef } from "react";
import FormItem from "antd/es/form/FormItem";
import Title from 'antd/es/typography/Title';
import { Typography } from 'antd';

export default forwardRef((props: any, ref: any) => {
  const { inputData, language } = props,
    { questions } = inputData;

  return (
    <FormItem
      style={{ textAlign: "center" }}
      colon={false}
    >
      <Typography>
        <Title type="secondary" level={4}><span dangerouslySetInnerHTML={{__html: questions[language]}} /></Title>
      </Typography>
    </FormItem>
  );
});
